<div class="advance-search-popup">
  <div class="modal-title-bg advance-search-header">
    <h2 class="text-white">{{ 'Advanced Search' | translate }}</h2>
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (loaderService.isLoad | async) {
    <div class="overlay">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }

  <div class="advance-search-body">
    <form [formGroup]="advanceSearchForm" #f="ngForm" class="form">
      <div class="search-type-section">
        <p class="section-label">{{ 'Search By' | translate }}</p>
        <mat-radio-group
          class="radio-row"
          formControlName="selectedSearchType"
          aria-label="Select an option"
          (change)="onChangeBySearchType()">
          <mat-radio-button value="1">{{ 'Store Number' | translate }}</mat-radio-button>
          <mat-radio-button value="2">{{ 'PO Number' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="section-divider"></div>

      <div class="report-type-section">
        <mat-radio-group
          class="radio-row"
          formControlName="selectedReportType"
          aria-label="Select an option"
          (change)="poOrderChange()">
          <mat-radio-button value="1">{{ 'OC' | translate }}</mat-radio-button>
          <mat-radio-button value="2">{{ 'RC' | translate }}</mat-radio-button>
          <mat-radio-button value="3">{{ 'Both' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="row">
        <div class="col">
          @if (userData && userData.roleId < 4) {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Store Number' | translate }}</mat-label>
              <input
                type="text"
                required
                aria-label="Number"
                matInput
                maxlength="6"
                (blur)="onchangeStore()"
                formControlName="storeNumber"
                [matAutocomplete]="storeAuto">
              <mat-autocomplete #storeAuto="matAutocomplete">
                @for (option of filteredOptions | async; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          @if (userData && userData.roleId > 3 && !textcomponent) {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Store Number' | translate }}</mat-label>
              <mat-select required formControlName="storeNumber" disableOptionCentering (selectionChange)="onchangeStore()">
                @for (store of user.stores; track store) {
                  <mat-option [value]="store.storeNumber">
                    {{ store.storeNumber }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (textcomponent) {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Store Number' | translate }}</mat-label>
              <input maxlength="6" readonly formControlName="storeNumber" matInput required />
            </mat-form-field>
          }
        </div>

        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'PO Number' | translate }}</mat-label>
            <input maxlength="50" formControlName="poNumber" matInput required />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Status' | translate }}</mat-label>
            <mat-select #select multiple formControlName="poStatus">
              <div class="select-all">
                <mat-checkbox formControlName="status" (change)="toggleAllSelection()">
                  {{ 'Select All' | translate }}
                </mat-checkbox>
              </div>
              @for (status of statusAll; track status) {
                <mat-option (click)="optionClick()" [value]="status.value">
                  {{ status.viewValue | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Signed By' | translate }}</mat-label>
            <input
              type="text"
              aria-label="Number"
              matInput
              formControlName="signedBy"
              [matAutocomplete]="signedByAuto">
            <mat-autocomplete #signedByAuto="matAutocomplete">
              @for (option of filteredUPN | async; track option) {
                <mat-option [value]="option.upn">
                  {{ option.fullName }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      <p class="date-section-label">
        {{ 'Created Date' | translate }} ({{ 'Applicable to OC and RC' | translate }})
      </p>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'From Date' | translate }}</mat-label>
            <input matInput [matDatepicker]="fromdatecd" formControlName="fromDateCd">
            <mat-datepicker-toggle matSuffix [for]="fromdatecd"></mat-datepicker-toggle>
            <mat-datepicker #fromdatecd></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'To Date' | translate }}</mat-label>
            <input matInput [matDatepicker]="todatecd" formControlName="toDateCd">
            <mat-datepicker-toggle matSuffix [for]="todatecd"></mat-datepicker-toggle>
            <mat-datepicker #todatecd></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <p class="date-section-label">
        {{ 'Received Date' | translate }} ({{ 'Applicable to RC only' | translate }})
      </p>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'From Date' | translate }}</mat-label>
            <input matInput [matDatepicker]="fromdaterc" formControlName="fromDateRc">
            <mat-datepicker-toggle matSuffix [for]="fromdaterc"></mat-datepicker-toggle>
            <mat-datepicker #fromdaterc></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'To Date' | translate }}</mat-label>
            <input matInput [matDatepicker]="todaterc" formControlName="toDateRc">
            <mat-datepicker-toggle matSuffix [for]="todaterc"></mat-datepicker-toggle>
            <mat-datepicker #todaterc></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="actions-row">
        @if (message) {
          <p class="error-message"><b>{{ message }}</b></p>
        }
        <div class="action-buttons">
          <button type="button" mat-raised-button class="modal-title-bg" (click)="search()">
            {{ 'Search' | translate }}
          </button>
          <button type="button" mat-raised-button class="modal-title-bg" (click)="clear()">
            {{ 'Clear' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
